import "./../Home/Home.css";
import PageHero from "../../components/PageHero/PageHero";
import JoinUs from "../../components/Blocks/JoinUsBlock/JoinUsBlock";
import SendCV from "../../components/Blocks/SendCvBlock/SendCVBlock";
import JobListBlock from "../../components/Blocks/JobListBlock/JobListBlock";
import StrengthsBlock from "../../components/Blocks/StrengthsBlock/StrengthsBlock";
import HSEBlock from "../../components/Blocks/HSEBlock/HSEBlock";
import CapabilityBlock from "../../components/Blocks/CapabilityBlock/CapabilityBlock";
import ExperienceHighlightBlock from "../../components/Blocks/ExperienceHighlightBlock/ExperienceHighlightBlock";
import GroupStrengthBlock from "../../components/Blocks/GroupStrengthBlock/GroupStrengthBlock";
import ExecutionApproachBlock from "../../components/Blocks/ExecutionApproachBlock/ExecutionApproachBlock";

function Careers({ content, loading }) {
  if (loading || !content) {
    return <div className="career-page">Loading...</div>;
  }

  return (
    <div className="career-page">

      <PageHero
        title={content.pageHero?.careers?.title}
        media={content.pageHero?.careers?.media}
      />

      <JoinUs
        smallTitle={content.joinUsBlock?.smallTitle}
        heading={content.joinUsBlock?.heading}
        description={content.joinUsBlock?.description}
        buttonText={content.joinUsBlock?.buttonText}
        image={content.joinUsBlock?.image}
      />

      <JobListBlock
        title={content.jobListBlock?.title}
        jobs={content.jobListBlock?.jobs}
      />

      <SendCV
        heading={content.sendCVBlock?.heading}
        description={content.sendCVBlock?.description}
        submitButtonText={content.sendCVBlock?.submitButtonText}
      />

      <StrengthsBlock
        title={content.block9?.title}
        items={content.block9?.items}
      />

      <HSEBlock
        smallTitle={content.block10?.smallTitle}
        title={content.block10?.title}
        description={content.block10?.description}
        image={content.block10?.image}
        checkpoints={content.block10?.checkpoints}
      />

      <CapabilityBlock
        badge={content.block11?.badge}
        title={content.block11?.title}
        description={content.block11?.description}
        highlight={content.block11?.highlight}
        capabilities={content.block11?.capabilities}
      />

      <ExperienceHighlightBlock
        backgroundImage={content.block12?.backgroundImage}
        title={content.block12?.title}
        mainValue={content.block12?.mainValue}
        mainDescription={content.block12?.mainDescription}
        features={content.block12?.features}
      />

      <GroupStrengthBlock
        title={content.block13?.title}
        intro={content.block13?.intro}
        sisterCompany={content.block13?.sisterCompany}
        regions={content.block13?.regions}
        stats={content.block13?.stats}
        footer={content.block13?.footer}
      />

      <ExecutionApproachBlock
        title={content.block14?.title}
        pillars={content.block14?.pillars}
      />

    </div>
  );
}

export default Careers;
